import { useSuspenseQuery } from "../client.ts";

export const useGetSessionSuspenseQuery = () => useSuspenseQuery("get", "/session");
